import "./pivot.css";
import { useEffect, useRef, useState, useCallback } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { assetsMap, imageInitializer } from "../../model/assets.js";
import { collectionsMap } from "../../model/collections.js";
import infoIcon from "../../assets/info.svg";
import flipIcon from "../../assets/flip.svg";

let scrollTimeout;
let windowsize;

export const PivotView = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get("id");
    const origin = urlParams.get("origin");
    const ctx = urlParams.get("ctx");
    windowsize = Boolean(collectionsMap[source].description);
    const pivotEl = useRef(null);
    const history = useNavigate();
    const [assets, setAssets] = useState(assetsMap);
    const [collection, setCollection] = useState([]);
    const [showInfo, setShowInfo] = useState(false);

    const onWheel = (ev) => {
        if (!ev.deltaY || ev.deltaX) return;
        clearTimeout(scrollTimeout);
        const container = document.querySelector(".pivot-container");
        container.classList.add("wheeledUnsmooth", "wheeledUnsnap");
        container.scrollLeft += ev.deltaY;
        scrollTimeout = setTimeout(() => {
            container.classList.remove("wheeledUnsmooth");
            scrollSnap();
            scrollTimeout = setTimeout(() => {
                container.classList.remove("wheeledUnsnap");
            }, 400);
        }, 100);
    }

    const navigate = useCallback(() => {
        const id = collection[0][0];
        history(`../gallery/view?id=${id}&origin=collections`, { replace: true });
    }, [collection, history]);

    const scrollSnap = useCallback((index) => {
        let element;
        const container = document.querySelector(".pivot-container");
        if (index) {
            element = container.children[index];
        } else {
            for (const asset of collection) {
                const el = document.querySelector(`#asset_${asset[0]} img`);
                const ws = window.matchMedia("(min-width: 701px)").matches && windowsize ? window.innerWidth / 2 : window.innerWidth;
                if (Math.abs(el.getBoundingClientRect().left + el.getBoundingClientRect().width / 2 - ws / 2) < 3 * el.getBoundingClientRect().width / 4) {
                    element = el.parentElement;
                }
            }
        }
        if (element) {
            container.scrollTo(element.offsetLeft + element.clientWidth / 2 - container.getBoundingClientRect().width / 2, 0);
        }
    }, [collection]);

    useEffect(() => {
        if (origin) {
            const index = collection.findIndex(i => i[0] === origin);
            if (index === -1) return;
            scrollSnap(collection.findIndex(i => i[0] === origin));
            window.history.replaceState({}, document.title, window.location.href.split("&origin=")[0]);
        }
        if (collection.length === 1 && !collection.description) {
            navigate();
        }
    }, [collection, origin, navigate, scrollSnap]);
    useEffect(() => {
        let timeout;
        if (assets.busy) {
            timeout = imageInitializer(setAssets);
        }
        if (collectionsMap[source].items) {
            setCollection(Object.entries(assetsMap).filter(i => collectionsMap[source].items.includes(i[0])));
        } else {
            setCollection(Object.entries(assetsMap).filter(i => i[1].collection === source));
        }
        return () => {
            clearTimeout(timeout);
        }
    }, [assets, source]);

    useEffect(() => {
        const oldColor = document.documentElement.style.getPropertyValue("--b-fullscreen");
        collectionsMap[source].colorTheme && document.documentElement.style.setProperty("--b-fullscreen", collectionsMap[source].colorTheme);
        if (collectionsMap[source].backgroundImage) {
            document.querySelector(".view.pivot").style.backgroundImage = `url(${ assetsMap[collectionsMap[source].backgroundImage].file })`;
        }
        document.documentElement.style.setProperty("--b-full", collectionsMap[source].background || "contain");
        document.documentElement.style.setProperty("--b-repeat", collectionsMap[source].displayPattern ? "repeat" : "no-repeat");
        document.querySelector("footer").style.display="none";
        const box = document.querySelector('.pivot-container');
        box.tabIndex = '-1';
        box.focus();
        return () => {
            clearTimeout(scrollTimeout);
            collectionsMap[source].colorTheme && document.documentElement.style.setProperty("--b-fullscreen", oldColor);
            collectionsMap[source].background && document.documentElement.style.setProperty("--b-full", null);
            collectionsMap[source].displayPattern && document.documentElement.style.setProperty("--b-repeat", null);
            document.querySelector("footer").style.display = null;
        }
    }, [origin, source, collection]);

    return (
        <div className={`view pivot fullscreen align-center ${windowsize ? 'description' : ''}`}>
            <Link to={`../${ctx || "collections"}`}><button className="reveal reveal-area action top left round align-center"><img draggable="false" alt="" width="35" height="35" src="https://saison.one/assetsCommon/navigation_arrow.svg"/></button></Link>
            <h2 className="view-title">{ collectionsMap[source].fullname || collectionsMap[source].name }</h2>
            <div className="pivotHeader"/>
            <div id={origin ? "unsnap": ""} className="pivot-container" onWheel={onWheel} ref={pivotEl}>
                {collection && collection.map((value, index) =>
                    <Link key={index} to={ `../gallery/view?id=${value[0]}&origin=${source}${ctx ? `&ctx=${ctx}`: ""}` }>
                        <div style={{position: "relative"}} id={`asset_${value[0]}`}>
                            <img draggable="false" className="content pivotElement" alt={value[1].name} src={ value[1].file }/>
                            {value[1].sideB && <img draggable="false" className="manyIcon themed round" height="18" alt="" src={flipIcon}/>}
                        </div>
                    </Link>
                )}
                <div className="safariFix" style={{position: "relative", width: "33vw"}}>
                    Safari acts differently
                </div>
            </div>
            {windowsize && <>
                    <div className="description-container" style={{background: collectionsMap[source].colorTheme || "var(--b-panel)"}}>
                        <p>
                            <FormattedMessage id={collectionsMap[source].description} values={{rtn: <><br/><br/></>, b: c => <b>{c}</b>, h3: c => <h3>{c}</h3>, center: c => <div className="align-center">{c}</div>, icon: c => <div className="align-center themed icon">{c}</div>, img: c => <img draggable="false" className="infoImg" alt="" src={assetsMap[c].file}/>}} />
                        </p>
                    </div>
                    <div className={`info ${showInfo ? "visible" : ""}`} style={{background: collectionsMap[source].colorTheme || "var(--b-panel)"}}>
                        <p><FormattedMessage id={collectionsMap[source].description} values={{rtn: <><br/><br/></>, b: c => <b>{c}</b>, h3: c => <h3>{c}</h3>, center: c => <div className="align-center">{c}</div>, icon: c => <div className="align-center themed icon">{c}</div>, img: c => <img draggable="false" className="infoImg" alt="" src={assetsMap[c].file}/>}} /></p>
                    </div>
                    <button className="reveal reveal-area action bottom right img align-center" onClick={() => setShowInfo(!showInfo)}>
                        <img draggable="false" className={`btn-info ${showInfo ? "active" : "inactive"}`} width="35" alt="" src={ infoIcon }/>
                        <span>Informations</span>
                    </button>
                </>
            }
        </div>
    );
}